class SizeGuideModal extends HTMLElement {

  constructor() {
    super();

    this.notification = document.getElementById('size-guide-modal');
    this.wrapper = document.querySelector('.size-guide-wrapper ');
    this.closeBtn = this.querySelector('.close');
    this.sizeGuideLink = document.querySelector('.size-guide-link');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.closeInterval = Number(this.dataset.closeInterval) || false;
    this.isMobile = window.matchMedia('(max-width: 749px)');

    if (this.sizeGuideLink) {
      this.sizeGuideLink.addEventListener('click', () => this.open())
    }

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.closeBtn.addEventListener('click', () => this.close());
  }

  open() {
    this.style.display = '';
    this.classList.add('active');
    this.notification.classList.add('animate', 'active');
    document.body.style.overflow = 'hidden';
    const isDesktop = window.matchMedia('(min-width: 750px)');
    const currentOffset = window.scrollY;

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.classList.remove('active');
    this.notification.classList.remove('active');

    document.body.style.overflow = '';
    this.style.display = 'none';

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target === this) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('size-guide-modal', SizeGuideModal);

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}